import { CurrencyCode, CurrencySymbol } from '@classity-edtech/platform-utils';

export const refinePricesUtil = ({
  formattedAmount,
  currency,
}: {
  formattedAmount: string;
  currency: CurrencyCode;
}) => {
  if (currency === CurrencyCode.NG) {
    const escapedCurrency = currency.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedCurrency, 'g');
    return formattedAmount.replace(regex, CurrencySymbol.NG);
  }

  return formattedAmount;
};
